// extracted by mini-css-extract-plugin
export default {"codeBtn":"Password_codeBtn__-JyVo","goToLoginBtn":"Password_goToLoginBtn__eMIgo"};